/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SimpleTableHelpers from './utils/helper';
import RowDnD from './RowDnD';
import styles from './simpletable.scss';

const stClassName = styles.stClassName.replace(/"/g, '');

class TBodyDnD extends Component {
	static propTypes = {
		rowLength: PropTypes.number,
		colToAddScopeRow: PropTypes.number,
		colLength: PropTypes.number,
		cellRenderer: PropTypes.func,
		onRowMove: PropTypes.func,
		widthDivision: PropTypes.object,
		height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		draggable: PropTypes.bool,
		onRowHover: PropTypes.func,
		onRowOut: PropTypes.func,
	};
	state = {};
	componentDidMount() {
		SimpleTableHelpers.resizeThead(this.tbody);
	}
	onSelect(row) {
		this[`rowdnd${row}`].onSelect(row);
	}
	_assignRef = (ref, index) => {
		this[`rowdnd${index}`] = ref;
	};
	render() {
		let height = {};
		if (this.props.height) {
			height = {
				height: this.props.height,
			};
		}

		const rows = [];
		for (let index = 0; index < this.props.rowLength; index++) {
			rows.push(
				<RowDnD
					onRef={ref => {
						this._assignRef(ref, index);
					}}
					key={index}
					rowKey={index}
					colToAddScopeRow={this.props.colToAddScopeRow}
					colLength={this.props.colLength}
					rowLength={this.props.rowLength}
					cellRenderer={this.props.cellRenderer}
					widthDivision={this.props.widthDivision}
					onRowHover={this.props.onRowHover}
					onRowMove={this.props.onRowMove}
					onRowOut={this.props.onRowOut}
					hoveredAbove={this.state.hoveredAbove}
					role="bodyRow"
				/>
			);
		}

		return (
			<tbody
				ref={r => {
					this.tbody = r;
				}}
				className={`${stClassName}-tbody`}
				style={height}
			>
				{rows}
			</tbody>
		);
	}
}

export default TBodyDnD;
